import React from 'react';
import cn from 'classnames';
import * as Fi from 'react-icons/fi';
import { Select, DateRangePicker } from 'ui/components';
import { formatDate } from 'utilities/common';

const initialState = {
  schedule: null,
};

const Filter = ({ show, onClose, scTable, setCount }) => {
  const [{ schedule }, setState] = React.useState(initialState);

  const $filterCustomer = (e) => {
    scTable?.filter('customer_id', e?.id);
    handleFilter();
  };

  const $filterDate = (e) => {
    setState((prevState) => ({
      ...prevState,
      schedule: e,
    }));

    let fm = [];
    e?.forEach((data) => fm?.push(formatDate(data, 'YYYY-MM-DD')));

    scTable?.filter('date_range', fm)
    handleFilter();
  };

  const handleFilter = async (e) => {
    if (scTable?.State?.filter) {
      let x = [];
      Object.keys(scTable?.State?.filter).forEach((k) => {
        if (
          scTable?.State?.filter[k] &&
          k !== 'start_at' && k !== 'document_status'
        ) {
          x.push(k);
        }
      });
      setCount(x);
    }
  };

  React.useEffect(() => {
    handleFilter();

    let date = [];

    if (scTable?.State?.filter?.start_at && scTable?.State?.filter?.end_at) {
      date.push(new Date(scTable?.State?.filter?.start_at));
      date.push(new Date(scTable?.State?.filter?.end_at));
    }

    setState((prevState) => ({
      ...prevState,
      schedule: date,
      loading: false,
    }));
  }, []);

  const FilterForm = () => {
    if (!show) return null;

    return (
      <>
        <div className="mb-3">
          <div className="page-pretitle text-secondary mb-2">Customer</div>
          <Select.Remote
            placeholder=""
            url="/partner"
            initialValue={scTable?.State?.filter?.customer_id}
            keys={scTable?.State?.filter?.customer_id}
            row={(d) => {
              return {
                value: d.id,
                label: d?.company_name
                  ? `${d.name} - ${d.company_name}`
                  : `${d.name}`,
              };
            }}
            params={{type: 'customer'}}
            onSelected={$filterCustomer}
          />
        </div>

        <div className="mb-3">
          <div className="page-pretitle text-secondary mb-2">
            Jadwal Dibuat
          </div>
          <DateRangePicker
            value={schedule}
            placeholder=""
            onChange={$filterDate}
          />
        </div>
      </>
    );
  };

  return (
    <>
      <div
        className={cn(
          show
            ? 'col-md-3 d-none d-md-block py-3 px-3 m-0 border-start'
            : 'd-none'
        )}
      >
        <div className="mb-3 border-bottom">
          <div className="d-flex align-items-center justify-content-between">
            <div className="page-pretitle fs-7 text-secondary">Filter</div>
            <div className="mt-n1">
              <button className="btn btn-action-close " onClick={onClose}>
                <Fi.FiX color="hsl(0deg 0% 81%)" size={18} />
              </button>
            </div>
          </div>
        </div>
        <FilterForm />
      </div>

      <>
        <div
          className={cn('filter-overlay', show ? 'd-block d-md-none' : '')}
          onClick={onClose}
        />
        <div
          className={cn(
            'filter-modal d-block d-md-none py-3',
            show ? 'filter-show' : ''
          )}
        >
          <div className="mb-3 border-bottom">
            <div className="d-flex align-items-center justify-content-between">
              <div className="page-pretitle fs-7 text-secondary">Filter</div>
              <div className="mt-n1">
                <button className="btn btn-action-close " onClick={onClose}>
                  <Fi.FiX color="hsl(0deg 0% 81%)" size={18} />
                </button>
              </div>
            </div>
          </div>

          <FilterForm />
        </div>
      </>
    </>
  );
};

export default Filter;
